module.exports = __webpack_public_path__ + "img/price-tag-line.b677916e.svg";